module.exports = __webpack_public_path__ + "static/media/healthysweets.e7fc6bc8.jpeg";